import React, { useEffect, useRef, useState } from "react";
import { PROMPT_BEFORE_IDLE } from "../../session/lib";
import ErrorBoundary from "../../ErrorBoundary";

interface IdleTimerModalProps {
  isOpen: boolean;
}

const IdleTimerModal: React.FC<IdleTimerModalProps> = ({ isOpen }) => {
  const [remainingTime, setRemainingTime] = useState<number>(
    Math.ceil(PROMPT_BEFORE_IDLE / 1000)
  );

  const intervalRef = useRef<NodeJS.Timer | null>(null);

  useEffect(() => {
    if (isOpen) {
      setRemainingTime(Math.ceil(PROMPT_BEFORE_IDLE / 1000)); // Reset time when modal opens
      intervalRef.current = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setRemainingTime(Math.ceil(PROMPT_BEFORE_IDLE / 1000)); // Reset time when modal closes
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Clear interval on unmount
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <ErrorBoundary>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-red-50 p-6 rounded-lg shadow-lg max-w-sm w-full">
          <h2 className="text-lg font-bold mb-4">You are idle for too long!</h2>
          <p className="mb-6">
            You will be logged out in {remainingTime} seconds.
          </p>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default IdleTimerModal;
